export class WebsiteBuilderDocuments {
    public id: number = null;
    public name: string = '';
    public path: string = '';
    public ext: string = '';
    public parent: number = null;
    public type: string = 'file';
    public children: WebsiteBuilderDocuments[]  = [];
    public showFolder: boolean = false;
    public fileViewPath: string = '';

    constructor(obj = null) {
        if (obj) {
            this.id = obj.id;
            this.name = obj.name;
            this.path = obj.path;
            this.ext = this.path ? this.path.split('.').pop() : '';
            this.parent = obj.parent;
            this.type = obj.type;
            this.fileViewPath = 'https://docs.google.com/viewer?url=' + encodeURIComponent(this.path);
        }
    }

}



// WEBPACK FOOTER //
// /app/src/app/types/website-builder/website-builder-documents.ts